import {logEvent} from 'firebase/analytics';
import {useEffect} from 'react';
import {useLocation} from 'react-router';
import {useAnalytics} from 'reactfire';
import {ComponentWithoutChildren} from '../react/types';

/* v8 ignore next -- @preserve */
export const PageViewLogger: ComponentWithoutChildren = () => {
  const analytics = useAnalytics();
  const location = useLocation();

  useEffect(() => {
    logEvent(analytics, 'page_view', {page_location: location.pathname});
  }, [analytics, location.pathname]);

  return null;
};
